"use client"

import { FloatingPlanets } from "./floatingPlanets";
import { NebulaBackground } from "./nebula";
import { ShootingStars } from "./shootingstars";
import { SpaceBackground } from "./spaceBackground";

export default function Background() {
    return (
        <>
            <div className="z-20" style={{ position: 'relative' }}>
                <FloatingPlanets />
            </div>
            <div className="z-10" style={{ position: 'relative' }}>
                <NebulaBackground />
                <ShootingStars />
                <SpaceBackground />
            </div>
        </>
    )
}